import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Form, Select } from 'antd';
import './styles.less';

const FormIsFeatured = ( { form, modifiedCallback, ref } ) => {      
    const [ isFeaturedValue, setisFeaturedValue ] = useState( false ); 

    useEffect( () => {
        setisFeaturedValue( form.getFieldValue( 'isFeatured' ) );
    }, [ form ] );

    useImperativeHandle( ref, () => ( {
        reset() {
            form.setFieldsValue( { isFeaturedModified: form.getFieldValue( 'isFeatured' ) } ); 
            form.setFieldsValue( { isFeaturedIsModified: false } );
            form.setFieldsValue( { isFeaturedModified: undefined } ); 
            setisFeaturedValue( form.getFieldValue( 'isFeatured' ) ); 
            modifiedCallback( false ); 
        }
    } ) );
    
    const handleOnChange = ( value ) => { 
        if ( form.getFieldValue( 'isFeatured' ) !== value ) {
            form.setFieldsValue( { isFeaturedIsModified: true } ); 
            form.setFieldsValue( { isFeaturedModified: value } ); 
            setisFeaturedValue( value );
            modifiedCallback( true ); 
        } else {
            form.setFieldsValue( { isFeaturedIsModified: false } ); 
            form.setFieldsValue( { isFeaturedModified: undefined } ); 
            setisFeaturedValue( value );
            modifiedCallback( false ); 
        }
    };
     
    return (
        <div className="form-item-is-featured">
            <Form.Item 
                label="Featured"
            >
                <Select
                    value={ isFeaturedValue }
                    onChange={ handleOnChange }
                    options={ [
                        { value: false, label: 'Not Featured' },
                        { value: true, label: 'Featured' }
                    ] }
                />
            </Form.Item>
        </div>
    );
};

export default FormIsFeatured;
